<section [ngClass]="(isWebSite$ | async) ? 'page_site' : 'page_cabinet'" class="page">
  <app-header
    [isWebSite]="isWebSite$ | async"
    [navItems]="navItems"
    [phones]="phones"
    [steps]="steps"
    [webSiteItems]="webSiteItems"
  ></app-header>
  <div class="page-container">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer
    [annex]="annex"
    [emails]="emails"
    [isWebSite]="isWebSite$ | async"
    [mod]="true"
    [phones]="phones"
    [routes]="footerWebsiteItems"
  ></app-footer>
</section>
